import request from "../request";

export class AboutSystemService {
  static get = async () => {
    return await request.get('/about');
  }
}
